module.exports = __webpack_public_path__ + "img/whispers_of_wood-hero--mobile.5846ee7.webp";